module.exports = __webpack_public_path__ + "img/code.26df2a66.png";